export const PageHero = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden"
    >
      {image && (
        <>
          <div
            className="absolute inset-0 -z-10"
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black/85 via-black/70 to-[color:var(--fk-bg)]" />
        </>
      )}
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          {eyebrow && <div className="eyebrow mb-6">{eyebrow}</div>}
          <h1 className="font-display text-5xl md:text-7xl leading-[1.05] tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-8 text-lg md:text-xl text-white/70 font-light max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
